import { render, staticRenderFns } from "./CustomerByCompany.vue?vue&type=template&id=63f260c6"
import script from "./CustomerByCompany.vue?vue&type=script&lang=js"
export * from "./CustomerByCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports